import React, { Component } from "react";
import { connect } from "react-redux";

import AlbumComponent from "./AlbumComponent";

import { saveAlbum } from "Thunks";
import { displaySidebarAlbums, resetSelectedMedia } from "Actions";

export class Album extends Component {
  render() {
    const {
      album,
      lng,
      checks,
      saveAlbum,
      displaySidebarAlbums,
      saveEvent
    } = this.props;

    return (
      <AlbumComponent
        album={album}
        language={lng}
        saveAlbum={saveAlbum}
        displaySidebarAlbums={displaySidebarAlbums}
        resetSelectedMedia={resetSelectedMedia}
        saveEvent={saveEvent}
        checks={checks}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  lng: state.params.lng,
  checks: state.medias.listing.checks
});

const mapDispatchToProps = dispatch => ({
  saveAlbum: options => dispatch(saveAlbum(options)),
  displaySidebarAlbums: visible => dispatch(displaySidebarAlbums(visible)),
  resetSelectedMedia: () => dispatch(resetSelectedMedia())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Album);



// WEBPACK FOOTER //
// ./src/components/Common/Album/index.js